const AllCalendarTypes = ['DATE_RANGE', 'SINGLE_DATE'] as const;

export type CalendarType = typeof AllCalendarTypes[number];

export { AllCalendarTypes };
